<template>
    <div>
        <div>
            <section v-if="!initialLoading">
                <div class="row">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table
                                id="data-table-list-users"
                                class="table table-hover-animation table-striped table-bordered"
                            >
                                <caption>
                                    Lista de usuarios
                                </caption>
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Nombre</th>
                                        <th scope="col">Curso inscrito</th>
                                        <th scope="col">Fecha de inscripción</th>
                                        <th scope="col">Estado de compra</th>
                                        <th scope="col">Pago pendiente</th>
                                        <th scope="col">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(user, index) in this.users"
                                        v-bind:key="index"
                                    >
                                        <td>
                                            <p style="width: 15px">{{ index + 1 }}</p>
                                        </td>
                                        <td>
                                            <p style="width: 220px">{{ user.name }}</p>
                                        </td>
                                        <td>
                                            {{ user.product_name }}
                                        </td>
                                        <td>
                                            {{ moment(user.created_at).format('DD/MM/YYYY hh:mm A') }}
                                        </td>
                                        <td>
                                            <el-tag
                                            v-if="user.status == 0"
                                            type="danger"
                                            disable-transitions
                                            >No comprado</el-tag
                                            >
                                            <el-tag
                                            v-else
                                            type="succes"
                                            disable-transitions
                                            >Comprado</el-tag
                                            >
                                        </td>
                                        <td>
                                            <el-tag
                                            v-if="user.pay_completed == 0"
                                            type="success"
                                            disable-transitions
                                            >Si</el-tag
                                            >
                                            <el-tag
                                            v-else-if="user.pay_completed == 1"
                                            type="danger"
                                            disable-transitions
                                            >No</el-tag
                                            >
                                        </td>
                                        <td>
                                            <button @click="userInfo(user)" class="btn btn-primary">Info</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
            <custom-spinner v-else></custom-spinner>
        </div>
        <el-dialog
            v-model="showModalInfo"
            title="Información del usuario"
            width="50%"
        >
            <div>
                <strong class="px-3">Nombres:</strong>{{ usuarioSeleccionado.name }}
            </div>
            <div>
                <strong class="px-3">Tipo de documento:</strong>{{ usuarioSeleccionado.doc_type_name }}
            </div>
            <div>
                <strong class="px-3">Nro. de documento:</strong>{{ usuarioSeleccionado.number_doc }}
            </div>
            <div>
                <strong class="px-3">Correo:</strong>{{ usuarioSeleccionado.email }}
            </div>
            <div>
                <strong class="px-3">Teléfono:</strong>{{ usuarioSeleccionado.phone }}
            </div>
            <div>
                <strong class="px-3">Fecha de inscripción:</strong>{{ moment(usuarioSeleccionado.updated_at).format('DD/MM/YYYY hh:mm A')}}
            </div>
            <div class="py-2">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Curso</th>
                                <th scope="col">Pago pendiente</th>
                                <th scope="col">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="delete">
                                <td colspan="3" class="text-center">Este usuario no tiene cursos comprados</td>
                            </tr>
                            <tr v-for="curso in cursos" :key="curso.id">
                                <td>{{ curso.nombre }}</td>
                                <td>
                                    <el-tag
                                    v-if="curso.pay_completed == 0"
                                    type="warning"
                                    disable-transitions
                                    >Si</el-tag
                                    >
                                    <el-tag
                                    v-else
                                    type="success"
                                    disable-transitions
                                    >No</el-tag
                                    >
                                </td>
                                <td>
                                    <button type="button" v-if="curso.pay_completed == 0" class="btn btn-primary" @click="payCourse(curso)">Pagar</button>
                                    <p v-else class="p-0 m-0">No aplica</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <template #footer>
            <span class="dialog-footer">
                <el-button type="primary" @click="showModalInfo = false">
                Cerrar
                </el-button>
            </span>
            </template>
        </el-dialog>
        <el-dialog
            v-model="showPayModal"
            title="Pagar fraccionamiento"
            width="50%"
        >
            <div>
                <div>{{ courseSelected.nombre }}</div>
                <div>
                    <p class="py-1 m-0"><strong>Precio del curso: </strong>S/. {{ courseSelected.precio }}</p>
                </div>
                <div>
                    <p class="py-1 m-0"><strong>Monto acumulado actual: </strong>S/. {{ courseSelected.total_paid }}</p>
                </div>
                <div>
                    <label for="">Monto a aportar</label>
                    <input v-model="amountPaid" type="number" name="amount" id="" class="form-control">
                </div>
            </div>
            <template #footer>
            <span class="dialog-footer">
                <el-button @click="showPayModal = false">Cancelar</el-button>
                <el-button type="primary" @click="savePayment()">
                Guardar
                </el-button>
            </span>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import moment from 'moment';
import CustomSpinner from "../../common/custom-spinner/CustomSpinner.vue";
import language from "../../api/traduction_es";

export default {
    data() {
        return {
            initialLoading: false,
            users: [],
            moment: moment,
            showModalInfo: false,
            courseSelected: [],
            showPayModal: false,
            amountPaid: 0,
        };
    },
    components: {
        "custom-spinner": CustomSpinner,
    },

    mounted() {
        this.listUsers();
    },

    methods: {
        loadDataTable() {
            $(document).ready(function () {
                $("#data-table-list-users").DataTable(language);
            });
        },
        listUsers: function () {
            this.initialLoading = true;
            axios.get(`/usuarios-invitados/list`).then((response) => {
                this.users = response.data;
                this.initialLoading = false;
                this.loadDataTable();
            });
        },
        async userInfo(user){
            this.usuarioSeleccionado = user;
            await axios.get(`/usuarios/verificar?user_id=${user.id}`).then((response) => {
                this.cursos = response.data.purchaseds
            })
            this.showModalInfo = true
        },
        payCourse(curso){
            this.courseSelected = curso;
            this.showPayModal = true;
        },
        async savePayment(){
            if(this.validateData()){
                const form = {
                    'payment_id': this.courseSelected.payment_id,
                    'amount': this.amountPaid
                }
                await axios.post('/payments/fractioned/pay', form).then((r) => {
                    console.log(r.data);
                    this.showPayModal = false;
                    this.showModalInfo = false;
                    this.listUsers();
                    this.userInfo(this.usuarioSeleccionado);
                    this.amountPaid = 0;
                    this.$message.success('El pago se realizó correctamente');
                });
            }
        },
        validateData(){
            if(this.amountPaid == ""){
                this.$message.warning('Ingrese el monto a pagar');
                return false;
            }
            if(this.amountPaid <= 0){
                this.$message.warning('Ingrese un monto adecuado');
                return false;
            }
            return true;
        },
    },
};
</script>
<style>
.el-icon {
    width: 20px;
}
.el-select .el-input .el-select__caret::before {
    display: none !important;
}
.el-icon .el-select__caret .el-select__icon {
    transform: rotateZ(0deg);
}
#customize_select {
    background-color: #ffffff !important;
    border: none !important;
    width: 0px !important;
    font-size: 0px !important;
    justify-content: center;
    text-align: center;
    padding: 0 !important;
}
</style>
